var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGodtvhelphover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 335.71,
    height: 466.26,
    viewBox: "0 0 335.71 466.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    isolation: "isolate"
  }, /*#__PURE__*/React.createElement("g", {
    isolation: "isolate"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.97,466.26h-85.51c-4.31,0-7.79-3.48-7.79-7.79v-85.51c0-4.31,3.48-7.79,7.79-7.79h85.51c4.31,0,7.79,3.48,7.79,7.79v85.51c0,4.31-3.48,7.79-7.79,7.79ZM204.06,351.23h-77.6c-4.25,0-7.71-3.41-7.79-7.65-.21-11.23-.3-18.08-.3-20.53,0-26.29,4.49-48.37,13.34-65.63,8.89-17.36,25.87-36.1,51.92-57.27,30.34-24.66,40.4-34.59,43.49-38.59,6.46-8.56,9.62-17.77,9.62-28.1,0-14.44-5.67-26.53-17.33-36.94-11.76-10.5-28.08-15.82-48.52-15.82s-36.15,5.47-49.43,16.71c-13.2,11.18-22.47,28.78-27.55,52.3-.85,3.95-4.5,6.7-8.57,6.09l-78.51-9.74c-4.09-.5-7.07-4.1-6.82-8.21,2.35-38.27,18.84-71.21,49.02-97.86C79.06,13.46,118.83,0,167.24,0c50.83,0,91.98,13.61,122.32,40.45,30.62,27.09,46.15,59.21,46.15,95.45,0,20.27-5.78,39.69-17.19,57.72-11.17,17.67-34.04,40.76-69.91,70.6-21.31,17.72-28.93,28.04-31.58,33.58-2.62,5.5-5.66,17.85-5.17,45.5.04,2.08-.77,4.11-2.24,5.6-1.46,1.49-3.46,2.33-5.55,2.33h0Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGodtvhelphover);
export default __webpack_public_path__ + "static/media/godtvhelphover.dc1f13d6744e4a63ada2e40f1c80db8c.svg";
export { ForwardRef as ReactComponent };